export const CONNECTION_ERROR_GRACE_PERIOD_MS = 3000;
export const createConnectionErrorReporter = (onError, gracePeriodMs = CONNECTION_ERROR_GRACE_PERIOD_MS) => {
    let timeoutId = null;
    let disposed = false;
    const report = (message) => {
        if (disposed || timeoutId !== null) {
            return;
        }
        timeoutId = setTimeout(() => {
            timeoutId = null;
            if (!disposed) {
                onError(message);
            }
        }, gracePeriodMs);
    };
    const clear = () => {
        if (timeoutId !== null) {
            clearTimeout(timeoutId);
            timeoutId = null;
        }
        if (!disposed) {
            onError(null);
        }
    };
    const dispose = () => {
        disposed = true;
        if (timeoutId !== null) {
            clearTimeout(timeoutId);
            timeoutId = null;
        }
    };
    return { report, clear, dispose };
};
//# sourceMappingURL=connection-error-reporter.js.map